import { DealerApi } from '@/services'
import useLogger from '@/composables/useLogger'
const logger = useLogger('DealerStore')

const dealerParams = payload => {
  return payload
}

const DealerStore = {
  namespaced: true,
  state: {
    dealers: [],
    dealer: {}
  },
  mutations: {
    saveDealers: (state, payload) => (state.dealers = payload.data),
    saveDealer: (state, payload) => {
      // handle cases were coming from API (.data) and from setting directly from list
      if (!payload) {
        state.dealer = {}
      } else if (payload.data) {
        state.dealer = payload.data
      } else {
        state.dealer = payload || {}
      }
    },
    resetDealer: state => {
      state.dealer = {}
    }
  },
  actions: {
    fetchDealers ({ state, commit }) {
      return new Promise((resolve, reject) => {
        DealerApi.fetchDealers()
          .then(response => {
            commit('saveDealers', response)
            resolve(state.dealers)
          })
          .catch(error => {
            reject(error)
          })
      })
    },
    createDealer ({ state, commit }, payload) {
      const dealerData = dealerParams(payload)
      return new Promise((resolve, reject) => {
        DealerApi.createDealer(dealerData)
          .then(response => {
            logger.trace('CreateDealer: Success')
            commit('saveDealer', response)
            resolve(state.dealer)
          })
          .catch(error => {
            reject(error)
          })
      })
    },
    updateDealer ({ state, commit }, payload) {
      const dealerData = dealerParams(payload)
      return new Promise((resolve, reject) => {
        DealerApi.updateDealer(dealerData)
          .then(response => {
            logger.trace('UpdateDealer: Success')
            commit('saveDealer', response)
            resolve(state.dealer)
          })
          .catch(error => {
            reject(error)
          })
      })
    },
    // determines if create or update should be used
    saveDealer ({ dispatch }, payload) {
      if (payload.id) {
        return dispatch('updateDealer', payload)
      } else {
        return dispatch('createDealer', payload)
      }
    },
    getDealer ({ state, commit }, payload) {
      return new Promise((resolve, reject) => {
        DealerApi.getDealer(payload)
          .then(response => {
            commit('saveDealer', response)
            resolve(state.dealer)
          })
          .catch(error => {
            reject(error)
          })
      })
    },
    setCurrentDealerByDmsKey ({ state, commit, dispatch }, payload) {
      const dmsKey = payload.dms_key
      const fetchDealersPromise = state.dealers.length === 0 ? dispatch('fetchDealers') : Promise.resolve()

      fetchDealersPromise.then(() => {
        const dealer = state.dealers.find(d => {
          return d.dms_key === dmsKey
        })
        commit('saveDealer', dealer)
      })
    }
  },
  getters: {
  }
}

export default DealerStore
